import React from 'react';
import PropTypes from 'prop-types';
import { ImageIcon, MusicIcon, FilmIcon, CloseIcon } from '../../../model/icons';

const TYPE_ICON = { IMAGE: ImageIcon, AUDIO: MusicIcon, VIDEO: FilmIcon };
const TYPE_ACCEPT = { IMAGE: 'image/*', AUDIO: 'audio/*', VIDEO: 'video/*' };
const TYPE_LABEL = { IMAGE: 'Загрузить изображение', AUDIO: 'Загрузить аудио', VIDEO: 'Загрузить видео' };

// Плитка медиа: превью (img/audio/video) с удалением ИЛИ дропзона загрузки.
export default function MediaTile({ type, url, onSelect, onRemove, disabled }) {
    const Icon = TYPE_ICON[type] || ImageIcon;

    if (url) {
        return (
            <div className="media-prev">
                {type === 'IMAGE' && <img src={url} alt="" />}
                {type === 'AUDIO' && <audio src={url} controls />}
                {type === 'VIDEO' && <video src={url} controls />}
                {onRemove && !disabled && (
                    <button type="button" className="media-rm" onClick={onRemove} aria-label="Удалить">
                        <CloseIcon />
                    </button>
                )}
            </div>
        );
    }

    if (disabled || !onSelect) return null;

    return (
        <label className="media-tile">
            <Icon />
            <span className="ml">{TYPE_LABEL[type] || 'Загрузить'}</span>
            <input
                type="file"
                accept={TYPE_ACCEPT[type] || 'image/*'}
                style={{ display: 'none' }}
                onChange={(e) => { const f = e.target.files?.[0]; if (f) { onSelect(f); e.target.value = ''; } }}
            />
        </label>
    );
}

MediaTile.propTypes = {
    type: PropTypes.oneOf(['IMAGE', 'AUDIO', 'VIDEO']),
    url: PropTypes.string,
    onSelect: PropTypes.func,
    onRemove: PropTypes.func,
    disabled: PropTypes.bool
};

MediaTile.defaultProps = { type: 'IMAGE', url: null, onSelect: null, onRemove: null, disabled: false };
